import { render, staticRenderFns } from "./RomaPurposeModalForm.vue?vue&type=template&id=9254bd4a"
import script from "./RomaPurposeModalForm.vue?vue&type=script&lang=ts"
export * from "./RomaPurposeModalForm.vue?vue&type=script&lang=ts"
import style0 from "./RomaPurposeModalForm.vue?vue&type=style&index=0&id=9254bd4a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports